import React from 'react';
import { ButtonLink, Icons } from "@sede-enterprise/shell-ds-react-framework"
import { useNavigate } from "react-router-dom";

const BackButton = () => {
    const navigate = useNavigate();
    return(
        <>
            <ButtonLink onClick={()=>{navigate(-1)}}><Icons.ArrowLeft />Back</ButtonLink>
        </>
    )
}

export default BackButton;